<template>
  <div class="flex p-1 space-x-1 bg-gray-100">
    <div
      v-for="tab in tabStore.tabs"
      :key="tab.path"
      class="px-2 py-0 mx-1 my-2 transition-all"
      :class="{
        'text-blue-500 bg-blue-50 font-semibold border border-blue-500 rounded': tab.path === tabStore.activePath,
        'bg-gray-100 text-black border border-gray-300 rounded duration-200 hover:text-blue-300 hover:bg-white hover:border-blue-300': tab.path !== tabStore.activePath,
      }"
    >
      <span @click="tabNavigate(tab.path)" class="cursor-pointer mr-2">
        {{ tab.name }}
      </span>
      <button
        @click="tabClose(tab.path)"
        class="ml-1"
        v-show="tab.path === '/scm/home' ? false : true"
      >
      <div class='w-5 h-5 translate-y-[4px]'
          :class="{
            'bg-blue-500': tab.path === tabStore.activePath,
            'bg-gray-300 duration-200 hover:bg-red-500': tab.path !== tabStore.activePath,
          }"
            :style="{ 
              maskImage: `url(${CloseIcon})`, 
              WebkitMaskImage: `url(${CloseIcon})`,
              maskSize: 'cover',
              WebkitMaskSize: 'cover'
            }"
          ></div>


        <!-- <img
          src="@/assets/img/close-circle.svg"
          class="w-5 h-5 translate-y-[4px]"
        /> -->
      </button>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";

import { useRouter } from "vue-router";
import { useTabStore } from "@/store/tabStore";

import CloseIcon from "@/assets/img/close-circle.svg";

import { XMarkIcon } from "@heroicons/vue/24/solid";

const router = useRouter();
const tabStore = useTabStore();

onMounted(() => {
  // console.log("✅ mounted 됨 (script setup)");
  // console.log("mounted tabStore", tabStore.path);
});

const tabNavigate = (path) => {
  // console.log("tabNavigate", path);
  // console.log("tabStore.tabs", tabStore.activePath);

  router.push(path);
  tabStore.setActiveTab(path);
};

const tabClose = (path) => {
  // console.log("tabClose", path);

  // 닫은 탭이 현재 활성 탭이라면 이전 탭으로 이동
  if (tabStore.activePath === path) {
    tabStore.removeTab(path);

    const tabs = tabStore.tabs;
    if (tabs.length > 0) {
      const lastTab = tabs[tabs.length - 1];

      tabStore.setActiveTab(lastTab.path);
      router.push(lastTab.path);
    } else {
      // 탭이 모두 닫혔을 경우 fallback 경로
      router.push("/"); // or login or default path
    }
  } else {
    tabStore.removeTab(path);
  }
};
</script>
